'use client'

import React from 'react'

interface BlogQuoteProps {
  quote: string
  author?: string
  title?: string
  company?: string
}

export function BlogQuote({ quote, author, title, company }: BlogQuoteProps) {
  const attribution = [author, title, company].filter(Boolean).join(', ')

  return (
    <div data-blog-layout='narrow' className='my-8'>
      <div className='rounded-2xl bg-[#F90B8A]/5 border-l-4 border-l-[#F90B8A] p-6 md:p-8'>
        <div
          style={{
            fontSize: 'clamp(1.125rem, 2vw, 1.5rem)',
            fontWeight: 700,
            fontStyle: 'normal',
            lineHeight: 1.5,
            color: 'var(--foreground)',
          }}
        >
          &ldquo;{quote}&rdquo;
        </div>
        {attribution && (
          <div
            style={{
              marginTop: '1rem',
              fontSize: '0.875rem',
              fontWeight: 500,
              color: '#F90B8A',
            }}
          >
            {attribution}
          </div>
        )}
      </div>
    </div>
  )
}

export default BlogQuote
